import isIGenesysFile from "./isIGenesysFile";
import { IGenesysFile } from "../interface/IMessage";

export default function getFileUrl(uploadFile: IGenesysFile | File): string {
  if (isIGenesysFile(uploadFile)) {
    return uploadFile.url;
  } else {
    return "";
  }
}
